import { create } from 'zustand';

export type TableCellKey = `${number},${number}`;

export interface TableCellSelectionState {
  anchorKey?: TableCellKey;
  selectedKeys: TableCellKey[];
}

interface TableCellStoreState {
  selections: Record<string, TableCellSelectionState | undefined>;
  setSelection: (nodeId: string, selection: TableCellSelectionState) => void;
  clearSelection: (nodeId: string) => void;
}

export const useTableCellStore = create<TableCellStoreState>()((set) => ({
  selections: {},
  setSelection: (nodeId, selection) =>
    set((state) => ({
      selections: { ...state.selections, [nodeId]: selection },
    })),
  clearSelection: (nodeId) =>
    set((state) => {
      const next = { ...state.selections };
      delete next[nodeId];
      return { selections: next };
    }),
}));

type TableCellStoreGlobal = typeof globalThis & {
  __E2E_TABLE_CELL_STORE__?: typeof useTableCellStore;
};

// Expose store for persisted-route E2E tests that need table-cell selection state.
const tableCellStoreGlobal = globalThis as TableCellStoreGlobal;
tableCellStoreGlobal.__E2E_TABLE_CELL_STORE__ = useTableCellStore;
